import React from 'react';
import './preview-keep-up.sass';
import { EmailSubmissionForm } from '../email-submission-form/email-submission-form';

export const PreviewKeepUp = () => {

    return(
        <div className='vv-preview-keepup'>
            <div className='vv-preview-keepup-empty-left'/>
            <div className='vv-preview-keepup__left'>
                <div className='vv-preview-keepup__left-container'>
                    <div className='vv-preview-keepup__left-box vv-preview-keepup__left-box--big'>
                        <p>Jesteś spoza Krakowa, ale chciałbyś być na bieżąco?</p>
                    </div>
                    <div className='vv-preview-keepup__left-box vv-preview-keepup__left-box--small'>
                        <p>Zapisz się do naszej bazy, a poinformujemy Cię o kolejnych wersjach aplikacji!</p>
                    </div>
                </div>
            </div>
            <div className='vv-preview-keepup__right'>
              <EmailSubmissionForm/>
            </div>
            <div className='vv-preview-keepup-empty-right'/>
        </div>
    );
};
